import Banner from '@rio-cloud/rio-uikit/Banner';
import { FormattedMessage } from 'react-intl';

import { useGetActivationSummaryQuery } from '../../../api/services/activationSummaryApiSlice';
import { MARKETPLACE_CUSTOMER_CENTER_CONTRACTS } from '../../../common/routes';
import { PeriodUnit } from '../../../common/termedLevel/types';

export const P1DContractsInfoBanner = () => {
    const { data: serviceList = [] } = useGetActivationSummaryQuery();

    const hasP1D = serviceList.some(service =>
        service.productRatePlans?.some(
            ratePlan => ratePlan.contractPeriod?.length === 1 && ratePlan.contractPeriod?.unit === PeriodUnit.DAY
        )
    );

    return (
        <div className={'margin-bottom-15'}>
            <Banner show={hasP1D} dismissible={false} initialAnimation={false}>
                <Banner.Page>
                    <Banner.Icon className='text-size-14'>
                        <span className='rioglyph rioglyph-info-sign text-size-200pct' />
                    </Banner.Icon>
                    <Banner.Content
                        title={<FormattedMessage id='marketplace.p1d.contracts.banner.title' />}
                        actions={<Banner.Actions />}
                    >
                        <p className='margin-bottom-5'>
                            <FormattedMessage
                                id='marketplace.p1d.contracts.banner.text'
                                values={{
                                    // @ts-expect-error
                                    link: (chunks: string[]) => (
                                        <a
                                            href={`/${MARKETPLACE_CUSTOMER_CENTER_CONTRACTS}`}
                                            target='_blank'
                                            rel='noreferrer'
                                        >
                                            {chunks}
                                        </a>
                                    ),
                                }}
                            />
                        </p>
                    </Banner.Content>
                </Banner.Page>
            </Banner>
        </div>
    );
};
